import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

enum StateMode {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  IN_REVIEW = 'in_review',
  INACTIVE = 'inactive'
}

@Component({
  selector: 'vfs-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StateComponent {
  @Input() mode: StateMode = StateMode.DRAFT;

  state = StateMode;
}
